/* eslint-disable no-console */
import * as Sentry from "@sentry/react";

type SeverityLevel = "error" | "warning" | "info" | "debug";

/**
 * Calls the appropriate Sentry methods to capture the given message or error
 * @param msgOrErr If an Error instance is given it will captureException, otherwise concatenate with the msg param
 * @param msg Will be joined into a string and captureMessage
 */
function captureSentry(
  level: SeverityLevel,
  msgOrErr: string | unknown,
  ...msg: string[]
) {
  if (typeof msgOrErr === "string") {
    Sentry.captureMessage([msgOrErr, ...msg].join(" "), level);
  } else if (msgOrErr instanceof Error) {
    msgOrErr.cause = msg.join(" ");
    Sentry.captureException(msgOrErr, { level });
  } else {
    Sentry.captureException(new Error(msg.join(" "), { cause: msgOrErr }), {
      level,
    });
  }
}

const consoleSeverityMap: Record<SeverityLevel, typeof console.log> = {
  error: console.error,
  warning: console.warn,
  info: console.info,
  debug: console.debug,
};

function captureConsole(level: SeverityLevel, ...msg: unknown[]) {
  consoleSeverityMap[level](...msg);
}

const capture = process.env.SENTRY_DSN ? captureSentry : captureConsole;

export const log = {
  debug: capture.bind(this, "debug"),
  info: capture.bind(this, "info"),
  warn: capture.bind(this, "warning"),
  err: capture.bind(this, "error"),
};
